import request from '@/utils/request'

export function pageOrderMasterBondItem(query) {
  return request({
    url: '/order/order-master-bond-item/page',
    method: 'get',
    params: query
  })
}

export function getOrderMasterBondItem(data) {
  return request({
    url: '/order/order-master-bond-item/detail',
    method: 'get',
    params: data
  })
}

export function addOrderMasterBondItem(data) {
  return request({
    url: '/order/order-master-bond-item/add',
    method: 'post',
    data: data
  })
}

export function updateOrderMasterBondItem(data) {
  return request({
    url: '/order/order-master-bond-item/edit',
    method: 'post',
    data: data
  })
}

export function delOrderMasterBondItem(data) {
  return request({
    url: '/order/order-master-bond-item/delete',
    method: 'post',
    data: data
  })
}
